import { VelocityEnv } from '@velocity-exchange/sdk';
import { EnvironmentConstants, RpcEndpoint } from '@velocity-exchange/common';

const HELIUS_DEFAULT_RPC_WEIGHT = 0.8;

const isHeliusRpc = (rpc: RpcEndpoint) => rpc.value.includes('helius');

export const getRpcOptions = (velocityEnv: VelocityEnv) => {
	return velocityEnv === 'devnet'
		? EnvironmentConstants.rpcs.dev
		: EnvironmentConstants.rpcs.mainnet;
};

export const chooseDefaultRpc = (rpcOptions: RpcEndpoint[]): RpcEndpoint => {
	if (rpcOptions.length === 0) {
		throw new Error('No RPC endpoints configured');
	}

	const heliusRpcs = rpcOptions.filter(isHeliusRpc);
	const nonHeliusRpcs = rpcOptions.filter((rpc) => !isHeliusRpc(rpc));

	if (heliusRpcs.length === 0 || nonHeliusRpcs.length === 0) {
		const pool = heliusRpcs.length > 0 ? heliusRpcs : rpcOptions;
		return pool[Math.floor(Math.random() * pool.length)];
	}

	const pool =
		Math.random() < HELIUS_DEFAULT_RPC_WEIGHT ? heliusRpcs : nonHeliusRpcs;

	return pool[Math.floor(Math.random() * pool.length)];
};
